import { FC } from 'react';
import theme from 'config/theme';
import { Link } from 'components/Link';
import Icon, { IconNames } from 'components/Icon';

interface Props {
  slates: string[];
  states: string[];
  types: string[];
  slateOptions: Array<{ label: string; value: string }>;
  stateOptions: Array<{ label: string; value: string }>;
  typeOptions: Array<{
    label: string;
    value: string;
    isGroup?: boolean;
    children?: Array<{ label: string; value: string }>;
  }>;
  onChange: (category: 'slates' | 'states' | 'types', values: string[]) => void;
  onClearAll: () => void;
}

interface FilterTag {
  id: string;
  label: string;
  category: 'slates' | 'states' | 'types';
  value: string;
}
interface Option {
  label: string;
  value: string;
  children?: Array<{ label: string; value: string }>;
}
export const FilterTags: FC<Props> = ({
  slates,
  states,
  types,
  slateOptions,
  stateOptions,
  typeOptions,
  onChange,
  onClearAll,
}) => {
  const getLabel = (value: string, category: 'slates' | 'states' | 'types') => {
    const options =
      category === 'slates' ? slateOptions : category === 'states' ? stateOptions : typeOptions;

    const findLabel = (opts: Option[]): string | undefined => {
      for (const opt of opts) {
        if (opt.value === value) {
          return opt.label;
        }
        if (opt.children) {
          const childLabel = opt.children.find(child => child.value === value)?.label;
          if (childLabel) {
            return childLabel;
          }
        }
      }
      return undefined;
    };

    return findLabel(options) || value;
  };

  const handleRemoveTag = (category: 'slates' | 'states' | 'types', value: string) => {
    const currentValues = category === 'slates' ? slates : category === 'states' ? states : types;
    onChange(
      category,
      currentValues.filter(v => v !== value)
    );
  };

  const handleClearAll = () => onClearAll();

  const allTags: FilterTag[] = [
    ...slates.map(value => ({
      id: `slates-${value}`,
      label: getLabel(value, 'slates'),
      category: 'slates' as const,
      value,
    })),
    ...states.map(value => ({
      id: `states-${value}`,
      label: getLabel(value, 'states'),
      category: 'states' as const,
      value,
    })),
    ...types.map(value => ({
      id: `types-${value}`,
      label: getLabel(value, 'types'),
      category: 'types' as const,
      value,
    })),
  ];

  if (allTags.length === 0) {
    return null;
  }

  return (
    <div className="filter-tags-container">
      <div className="row input-item-list">
        {allTags.map(tag => (
          <button
            key={tag.id}
            className="input-item filter"
            onClick={() => handleRemoveTag(tag.category, tag.value)}
          >
            <span className="body-small-text">{tag.label}</span>
            <Icon name={IconNames.XClose} size={18} color={theme.colors.inkBlue} />
          </button>
        ))}
      </div>
      <Link onClick={handleClearAll}>
        <span className="body-small-text">Clear</span>
      </Link>
    </div>
  );
};
